import { DefaultService as ScanJobSDK } from '@atbay/scan-job-manager-node-sdk'
import { createClient } from '@core/base/http-client'

// @ts-ignore
export const ScanJobClient = createClient(ScanJobSDK)
